import React, { useState } from "react";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Loader,
  HyphenIcon,
  Accordion,
  AccordionHeader,
  AccordionHeaderName,
} from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { services } from "../../../../dependencies";
import { useApiRequest } from "../../../../utils/http-client";
import { ProgramSettingsModal } from "../modals";

import "./disciplines.section.scss";

export const ProgramSection = ({ className, organization }) => {
  const { programsService } = services;
  const [open, setOpen] = useState(false);
  const { response: courses, loading } = useApiRequest(() =>
    programsService.getCoursesByOrgCode(organization?.code),
  );
  return (
    <div
      className={clsx("disciplines-section", loading && "loader", className)}
    >
      <div className="disciplines-section-header">
        <h2>
          Programs{" "}
          <span className="badge">{courses?.length ?? <HyphenIcon />}</span>
        </h2>
        <Button className="icon" onClick={() => setOpen(true)}>
          <FontAwesomeIcon icon="far fa-gear" />
        </Button>
        <ProgramSettingsModal
          open={open}
          organization={organization}
          onClose={() => setOpen(false)}
        />
      </div>

      <div className="content-section">
        {courses?.map((course) => (
          <Accordion key={`program-${course.id}`}>
            <AccordionHeader>
              <AccordionHeaderName>{course.title}</AccordionHeaderName>
            </AccordionHeader>
          </Accordion>
        ))}
        {loading && <Loader overlay fixed />}
      </div>
    </div>
  );
};
